import { render, staticRenderFns } from "./classStudent.vue?vue&type=template&id=43aaa42e&scoped=true"
import script from "./classStudent.vue?vue&type=script&lang=js"
export * from "./classStudent.vue?vue&type=script&lang=js"
import style0 from "./classStudent.vue?vue&type=style&index=0&id=43aaa42e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43aaa42e",
  null
  
)

export default component.exports